<template>
  <button class="swap-btn" @click="onClick">ИЗМЕНИТЬ МИР</button>
</template>

<style lang="scss">
.swap-btn {
  background-color: #0e0e0f;
  border-radius: 15px;
  border-style: solid;
  border-width: 2px;
  border-color: #18181a;

  box-sizing: border-box;

  display: flex;
  justify-content: center;
  align-items: center;

  font-family: "Minecraft Five";
  font-size: 14px;
  color: white;

  cursor: pointer;

  width: 352px;
  height: 43px;

  transition-property: background-color;
  transition-timing-function: ease-out;
  transition-duration: 250ms;

  &:hover {
    background-color: #262628;
  }
}
</style>

<script>
export default {
  name: "SwapWorld",
  methods: {
    async onClick() {
      if (
        !this.$bluemap?.maps ||
        !this.$bluemap?.mapViewer ||
        this.$bluemap.maps.length === 0
      )
        return;
      let index = this.$bluemap.maps.findIndex(
        (map) => map.data.id === this.$bluemap.mapViewer.map.data.id,
      );

      index = (index + 1) % this.$bluemap.maps.length;

      const id = this.$bluemap.maps[index].data.id;
      await this.$bluemap.switchMap(id, true);
    },
  },
};
</script>
